import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=4933d047&scoped=true&"
import script from "./DialogContainer.vue?vue&type=script&lang=ts&"
export * from "./DialogContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DialogContainer.vue?vue&type=style&index=0&id=4933d047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933d047",
  null
  
)

export default component.exports